import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import * as React from 'react';
import { connect } from 'react-redux';
import cookie from 'js-cookie';
import { createServiceProspect as createServiceProspectAction } from '../../../state/actions';
import { default as serviceCustomerHTTP } from '../../../services/serviceCustomer';
import { default as providerHTTP } from '../../../services/provider';
import Bugsnag from '../../../utils/bugsnag';
import { CookieName } from '../../../utils/constants';
import { UserServiceRelationshipType } from '../../../enums/user-service-relationship-type';
import { ServiceNewsletter } from '.';
import { jsx as _jsx } from "react/jsx-runtime";

var ServiceNewsletterContainer = function ServiceNewsletterContainer(_ref) {
  var accessToken = _ref.accessToken,
      currentUser = _ref.currentUser,
      createServiceProspect = _ref.createServiceProspect,
      redirectBack = _ref.redirectBack,
      service = _ref.service;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isServiceCustomer = _React$useState2[0],
      setIsServiceCustomer = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      serviceProspectExists = _React$useState4[0],
      setServiceProspectExists = _React$useState4[1];

  var userId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
  var serviceId = service === null || service === void 0 ? void 0 : service.id;

  var setUserServiceConnection = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getUserRelationShipToService, serviceCustomer, userRelationshipToService;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              getUserRelationShipToService = providerHTTP.getUserRelationShipToService;

              if (!accessToken) {
                _context.next = 11;
                break;
              }

              _context.next = 5;
              return serviceCustomerHTTP.getServiceCustomersByUserIdAndServiceId(userId, serviceId);

            case 5:
              serviceCustomer = _context.sent;
              _context.next = 8;
              return getUserRelationShipToService(serviceId);

            case 8:
              userRelationshipToService = _context.sent;
              setIsServiceCustomer(Boolean(serviceCustomer));
              setServiceProspectExists(userRelationshipToService.type === UserServiceRelationshipType.LEAD);

            case 11:
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              Bugsnag.notify(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 13]]);
    }));

    return function setUserServiceConnection() {
      return _ref2.apply(this, arguments);
    };
  }();

  React.useEffect(function () {
    if (Boolean(serviceId) && Boolean(userId)) {
      setUserServiceConnection();
    }
  }, [serviceId, userId]);
  return service && !isServiceCustomer ? /*#__PURE__*/_jsx(ServiceNewsletter, {
    currentUser: currentUser,
    providerService: service,
    createServiceProspect: createServiceProspect,
    serviceProspectExists: serviceProspectExists,
    redirectBack: redirectBack
  }) : null;
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.auth.users.current,
    accessToken: cookie.get(CookieName.ACCESS_TOKEN)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    createServiceProspect: function createServiceProspect(payload) {
      return dispatch(createServiceProspectAction(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceNewsletterContainer);